<template>
  <div class="realisation">
    <vue-glide
      class="demo"
      ref="carou"
      type="carousel"
      :perView="2"
      focusAt="center"
      v-model="active"
    >
      <vue-glide-slide v-for="(photo) in fullImages" :key="photo" >
        <div class="photoStudios">
          <img class="imageReno" :src="getImage(photo)"/>
        </div>
      </vue-glide-slide>
      <template slot="control">
          <button
            class="slider__arrow slider__arrow--prev glide__arrow glide__arrow--prev"
            data-glide-dir="<"
          >
            &lt;
          </button>
          <button
            class="slider__arrow slider__arrow--next glide__arrow glide__arrow--next"
            data-glide-dir=">"
          >
            &gt;
          </button>
        </template>
      </vue-glide>
</div>
</template>

<script>
import jsonData from "../data/dataSpecificStudio.json";
import jsonDataText from "../data/dataStudiosText.json";
import jsonDataTitle from "../data/dataSpecificStudioTitle.json";

export default {
  name: "SpecificStudio",

  data() {
    return {
      txt: [],
      title: "",
      rawImages: jsonData,
      dataText: jsonDataText,
      dataTitle: jsonDataTitle,
      fullImages: jsonData,
    };
  },
  mounted() {
    this.fullImages = [];
    for (let i in this.rawImages) {
      if (i == this.$route.params.id) {
        this.txt = this.dataText[i].split(";");

        this.title = this.dataTitle[i];
        for (let image in this.rawImages[i]) {
          this.fullImages.push(this.rawImages[i][image]);
        }
      }
    }
  },
  methods: {
    getImage: function(photo) {
      return require(`../assets/${this.$route.params.id}/${photo}`);
    },
  },
};
</script>

<style scope>
.photoStudios,
.imageReno {
  width: 100%;
}
.photoStudios {
  height: 100vh;
  display: flex;
  align-items: center;
}
.topImage,
.overImg {
  width: 75%;
}
.line {
  width: calc(69% / 2);
}
.topImg {
  max-width: 80%;
}
@media only screen and (min-width: 375px) and (max-width: 812px) {
  .line {
    width: calc(62% / 2);
  }
  .innerSpan {
    width: 100px;
  }
}
.inText {
  margin-top: 215px;
}
.realisation {
  flex-wrap: wrap;
}
.blueimp-gallery > .prev,
.blueimp-gallery > .next {
  line-height: 30px;
}
.blueimp-gallery > .next {
  padding-left: 4px;
}
.blueimp-gallery > .prev {
  padding-right: 4px;
}
.imageGallery {
  -webkit-transition: all 0.5s ease; /* Safari and Chrome */
  -moz-transition: all 0.5s ease; /* Firefox */
  -ms-transition: all 1s ease; /* IE 9 */
  -o-transition: all 1s ease; /* Opera */
  transition: all 1s ease;
}

.imageGallery:hover {
  -webkit-transform: scale(1.25); /* Safari and Chrome */
  -moz-transform: scale(1.25); /* Firefox */
  -ms-transform: scale(1.25); /* IE 9 */
  -o-transform: scale(1.25); /* Opera */
  transform: scale(1.25);
}
.glide__arrow {
  position: absolute;
  display: block;
  top: 50%;
  z-index: 2;
  color: white;
  text-transform: uppercase;
  padding: 9px 12px;
  background-color: transparent;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.1);
  text-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.1);
  opacity: 1;
  cursor: pointer;
  transition: opacity 150ms ease, border 300ms ease-in-out;
  transform: translateY(-50%);
  line-height: 1;
}
.glide__arrow:focus {
  outline: none;
}
.glide__arrow:hover {
  border-color: white;
}
.glide__arrow--left {
  left: 2em;
}
.glide__arrow--right {
  right: 2em;
}
.glide__arrow--disabled {
  opacity: 0.33;
}
.glide__bullets {
  position: absolute;
  z-index: 2;
  bottom: 2em;
  left: 50%;
  display: inline-flex;
  list-style: none;
  transform: translateX(-50%);
}
.glide__bullet {
  background-color: rgba(255, 255, 255, 0.5);
  width: 9px;
  height: 9px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid transparent;
  transition: all 300ms ease-in-out;
  cursor: pointer;
  line-height: 0;
  box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.1);
  margin: 0 0.25em;
}
.glide__bullet:focus {
  outline: none;
}
.glide__bullet:hover,
.glide__bullet:focus {
  border: 2px solid white;
  background-color: rgba(255, 255, 255, 0.5);
}

.glide__bullet--active {
  background-color: white;
}
.glide--swipeable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.glide--dragging {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.slider__arrow--next {
  right: 0;
}
.glide__slide {
  height: auto !important;
}
</style>
